import React from 'react';
import { Wrapper } from './styled';

const WorkspaceCell = ({ data }) => {
  const values = data?.map((e) => e?.workspace_name)?.join(', ');

  return <Wrapper title={ values } children={ values || '' } />;
};

export default WorkspaceCell;
